import React from "react";
import { Flex } from "@chakra-ui/react";
import { ActionsEnum } from "../../duck";
import { DEFAULT_ACTIONS, ACTIONS_BY_KEY } from "./duck";

interface ToolbarProps {
  availableActions?: ActionsEnum[];
  isHiding: boolean;
}

const Toolbar: React.FC<ToolbarProps> = ({
  availableActions = DEFAULT_ACTIONS,
  isHiding
}) => {
  return (
    <Flex
      data-testid="redactor-toolbar"
      py={1}
      px={3}
      gap={2}
      flexWrap="wrap"
      alignItems="center"
      onMouseDown={e => {
        // prevent loosing text selection in editor, when clicking on empty space in toolbar
        if (e.target === e.currentTarget) e.preventDefault();
      }}
      {...(isHiding && {
        position: "absolute",
        top: "calc(100% + 4px)",
        background: "white",
        zIndex: 3,
        boxShadow: "lg",
        borderRadius: "6px"
      })}
    >
      {availableActions.map(actionName => {
        return React.createElement(ACTIONS_BY_KEY[actionName], {
          key: actionName
        });
      })}
    </Flex>
  );
};

export default Toolbar;
